import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default {

    fetchPaginated: (sortName = "id", page, itemsPerPage, type = "ASC", word = "") => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
            return axios.post('', formatGraphqlBody(
            'query',
                'relationshipRuleCategoriesPaginated',
                {
                    0: 'pagination_page',
                    1: 'pagination_limit',
                    2: 'total_pages',
                    3: 'total_items',
                    items: {
                        0: 'id',
                        1: 'name',
                        2: 'color_tag'
                    }
                },
                {
                    orderBy: [sortName, type],
                    search_filter: word,
                    pagination_page: page,
                    pagination_limit: itemsPerPage
                }
            ));
    },
    add(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
            return axios.post('', {
            query: `
                mutation {
                    createRelationshipRuleCategory (
                    name: "${data.name}",
                    color_tag: "${data.color_tag}",
                    ) {
                        id,
                        name,
                        color_tag
                    }
                }
                `
            })
    },
    delete(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
            return axios.post('', {
            query: `
                mutation {
                deleteRelationshipRuleCategory (
                        id: ${id},
                    )
                }
            `
            })
    },
    update(id, data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
            return axios.post('', {
            query: `
                mutation {
                    updateRelationshipRuleCategory (
                        id: ${id}
                        name: "${data.name}",
                        color_tag: "${data.color_tag}",
                    ) {
                        id,
                        name,
                        color_tag,
                    }
                }
            `
            })
    },
    fetchById(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
        query: `
            query {
                relationshipRuleCategoriesInfos (
                    id: ${id},
                ) {
                    id,
                    name,
                    color_tag,
                  }
            }        
            
            `
        })
    },
    fetchAll(removeIds = []) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    relationshipRuleCategories(
                        remove_ids: [${removeIds.join(',')}]) 
                        {
                        id,
                        name,
                        color_tag,
                    }
                }
            `
        })
    },
}